
import { getStateSliceFor } from 'redux/Studio';
import { assistantReducerKey } from './reducer';

/** Returns the app data state slice. */
const extractDataFrom = state => getStateSliceFor({ state, reducerKey: assistantReducerKey });

export const getHelpNote = (state) => {
  let { helpNote } = extractDataFrom(state);
  return helpNote;
};

export const getRedesignOptions = (state) => {
  let { redesignOptions } = extractDataFrom(state);
  return redesignOptions;
};

export const getRedesignRating = (state) => {
  let { redesignRating } = extractDataFrom(state);
  return redesignRating;
};

export const getRedesignRatingAddlFeedback = (state) => {
  let { redesignRatingAddlFeedback } = extractDataFrom(state);
  return redesignRatingAddlFeedback;
};
